export const BABY_NAMES_HEADLINES = {
  en: "Baby Names by Nakshatra",
  // Baby-name searches, not "जन्म तारीख से नाम और राशि", which
  // /hi/rashi-calculator/ owns (owner, 2026-10-29; messages/hi.ts "baby-names").
  hi: "नक्षत्र से बच्चे का नाम — नामकरण के अक्षर",
} as const;
/**
 * The engine-derived direct answers for /baby-names/ and /hi/baby-names/ (AEO).
 *
 * Every fact is COMPOSED from the governed nakshatra domain data
 * (packages/domain-data, codegen from backend YAML), never authored and never
 * LLM-written (rules 24/29). The per-nakshatra pages were removed on
 * 2026-09-23 (HTTP 410); the hub calculator resolves one nakshatra's syllables.
 */

import { nakshatras } from "@ishvaram/domain-data";

/**
 * The hub answer for /baby-names/: the roster length and every nakshatra's own
 * pada-letter list come from the codegen'd domain data (baby_names.yaml), so
 * the counts cannot drift from the data the calculator and the letters table
 * render.
 */
export function babyNamesHubAnswer(): string {
  const nakshatraCount = nakshatras.length;
  const padaCount = nakshatras.reduce((acc, n) => acc + n.letters.length, 0);
  return (
    `Vedic naamkaran chooses a baby's name from the Janma Nakshatra — the ` +
    `lunar mansion the Moon occupied at the exact birth time. Each of the ` +
    `${nakshatraCount} nakshatras divides into four padas, and every pada ` +
    `prescribes its own starting syllable, so the birth moment fixes one of ` +
    `${padaCount} traditional name-starting sounds.`
  );
}

/**
 * The Hindi twin of the hub answer. ONE governed roster yields both locales, so
 * /baby-names/ and /hi/baby-names/ can never state different counts (rules
 * 23/24) — the timing-answer.ts EN/HI pattern.
 */
export function babyNamesHubAnswerHi(): string {
  const nakshatraCount = nakshatras.length;
  const padaCount = nakshatras.reduce((acc, n) => acc + n.letters.length, 0);
  return (
    `वैदिक नामकरण में बच्चे का नाम जन्म नक्षत्र से चुना जाता है — वह नक्षत्र जिसमें जन्म के ` +
    `ठीक समय चंद्रमा स्थित होता है। ${nakshatraCount} नक्षत्रों में से हर एक चार पदों में ` +
    `बँटा है और हर पद का अपना प्रारंभिक अक्षर होता है, इसलिए जन्म का क्षण ${padaCount} ` +
    `पारंपरिक नाम-अक्षरों में से एक तय करता है।`
  );
}
